import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SponsorDataService } from './../services/sponsor_data.service';
import { scaleIn, slideMenu, slideIn, fadeInOut } from '../../shared/animations/modal.animation';
import { Amplify, Auth } from 'aws-amplify';

@Component({
  selector: 'app-view-sponsor',
  templateUrl: './view-sponsor.component.html',
  styleUrls: ['./view-sponsor.component.css'],
  animations: [scaleIn, slideMenu, slideIn, fadeInOut]
})
export class ViewSponsorComponent implements OnInit {

  @Input() property: any;
  @Input() visible = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public imageBaseUrl = "https://cherymaupps3gradebookexample.s3.amazonaws.com/";
  public isLoading: boolean;
  username: string;
  isHidden: boolean;
  userLoggedIn: boolean;
  userGroup: any;
  public displayAppForm: any;

  constructor(@Inject(DOCUMENT) private document: any, private sp_ds: SponsorDataService) { }


  ngOnInit() {
    this.getCurrentAuthenticatedUser();

    this.sp_ds.change.subscribe((data) => {
      this.displayAppForm = data;
    })
  }

  getCurrentAuthenticatedUser() {
    const user = Auth.currentAuthenticatedUser()
      .then((user) => {
        this.username = user.attributes.name + " " + user.attributes.family_name;
        this.isHidden = false;
        this.userLoggedIn = true;

        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
      },
        (error) => {
          // console.log("authentication error", error);

          this.isHidden = true;
        });
  }

  logTest() {
    // console.log("Recieved Property");
  }

  close() {
    this.document.body.style.overflow = 'visible';
    this.visible = false;
    this.visibleChange.emit(this.visible);
    setTimeout(() => {
    }, 1000);
  }

  show(): void {
    this.document.body.style.overflow = 'hidden';
    this.visible = true;
  }

  apply() {
    this.displayAppForm = true;
    this.close();
  }

}
